import { useQuery } from '@tanstack/react-query';
import { useNavigate, useParams } from 'react-router-dom';

import timelineClient, { ITimelineItem } from '@clients/timelineClient';
import TimelinePanel from '@components/overviewPanels/timelinePanel/TimelinePanel';
import { useAccount } from '@contexts/AccountProvider';
import notifyAPIError from '@utils/notifyAPIError';

const { getTimeline } = timelineClient();

const TimelinePanelContainer = () => {
    const navigate = useNavigate();
    const { accountId } = useParams();
    const { isLoading: isLoadingAccounts } = useAccount();

    const NO_OF_ITEMS_TO_DISPLAY = 3;

    const {
        data: timelineData,
        isError,
        isLoading: timelineLoading,
    } = useQuery(
        [
            'timelineOverviewDetails',
            { accountID: accountId, pageSize: NO_OF_ITEMS_TO_DISPLAY },
        ],
        () =>
            getTimeline({
                accountId: parseFloat(accountId),
                pageSize: NO_OF_ITEMS_TO_DISPLAY,
            }),
        {
            onError: notifyAPIError,
        },
    );

    const handleOnClick = () => {
        navigate(`/${accountId}/timeline`);
    };

    const panels: ITimelineItem[] = timelineData?.items.map(
        (timelineDataItem) => timelineDataItem,
    );

    return (
        <TimelinePanel
            isLoading={timelineLoading || isLoadingAccounts}
            onClick={handleOnClick}
            panels={panels}
            totalItemsToDisplay={NO_OF_ITEMS_TO_DISPLAY}
            isError={isError}
        />
    );
};

export default TimelinePanelContainer;
